export default "__VITE_ASSET__BIKBZ9Lm__"